import { 
    apiClient
} from "./APIService";

export const createShopifyCheckout = (data) => {
    return apiClient.post('/shopify/checkout/create', data,{
        headers: {
            "x-access-token": localStorage.getItem('jwt')
        },
    })
}